import styles from './index.module.sass';
import plusSvg from '@@/buyer-account/images/plus.svg';

export const AddOfferButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={styles.root} onClick={onClick}>
      <img src={plusSvg} alt="plus" />
      <span>
        добавить <br />
        новое предложение
      </span>
    </div>
  );
};
